import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, rufe } from "./client";

export interface Ich {
  angemeldet: boolean;
  benutzer?: { id: string; email: string; name: string; istAnbieter: boolean; totpAktiv: boolean };
  totpAktiv?: boolean;
  totpPflicht?: boolean;
  sitzung?: { bereich: "laden" | "mieter" | "admin" | "kasse"; ladenId: string | null; art: "web" | "geraet"; zweiterFaktor: boolean };
  rolle?: "inhaber" | "mitarbeiter" | "aushilfe" | null;
  rechte?: string[];
  laeden?: { ladenId: string; name: string; slug: string; rolle: string }[];
  mieterIn?: { ladenId: string; name: string; slug: string; mieterId: string }[];
  /** E13.3: zeitlich begrenzter Support-Zugang des Anbieters. */
  support?: { bis: string } | null;
}

export function useIch() {
  return useQuery({
    queryKey: ["ich"],
    queryFn: () => rufe<Ich>(api.api.auth.ich.$get()),
    staleTime: 60_000,
  });
}

export function useAbmelden() {
  const qc = useQueryClient();
  return async () => {
    await rufe(api.api.auth.abmelden.$post());
    qc.clear();
    window.location.assign("/anmelden");
  };
}
